import type { RouteStop } from '../../../data/routeStops';

/**
 * 駅選択ドロップダウン。
 * - stops は stop_sequence 昇順で渡される前提。
 * - value が stops に存在しない (= マスタ未取得 / 別バージョン) 場合も選択肢として残し、
 *   既存値が消えないようにする。
 */
export function StopSelect({
  ariaLabel,
  testId,
  value,
  stops,
  disabled,
  invalid = false,
  onChange,
}: {
  ariaLabel: string;
  /**
   * data-testid 属性。E2E 等から `[data-testid="..."]` で一意に拾うため。
   * aria-label が「乗換駅」「遅延判定開始駅」のように似通っており AI/E2E が
   * 取り違えやすいので、明示的な testid を渡せるようにしている。
   */
  testId?: string;
  value: string;
  stops: RouteStop[];
  disabled?: boolean;
  /**
   * 保存時のバリデーションでこの欄がエラーになったか。
   *
   * `true` のとき `.is-invalid` (赤枠) を付けて「ここが原因」と一目で分かるようにする。
   * 「どの項目でエラーになったか分かりにくい」対策の一部で、既定値 `false` の場合は
   * 従来と完全に同じ見た目になる。
   */
  invalid?: boolean;
  onChange: (stopId: string) => void;
}): React.JSX.Element {
  const isUnknownStop = value !== '' && !stops.some((s) => s.stop_id === value);
  return (
    <select
      aria-label={ariaLabel}
      data-testid={testId}
      className={invalid ? 'is-invalid' : undefined}
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">(指定なし)</option>
      {stops.map((s) => (
        <option key={s.stop_id} value={s.stop_id}>
          {s.stop_name || s.stop_id}
        </option>
      ))}
      {isUnknownStop ? <option value={value}>{value} (駅一覧にない駅)</option> : null}
    </select>
  );
}
